<form [attr.disabled]="configurationForm().disabled">
  <glxy-form-field>
    <glxy-label>{{ 'AI_ASSISTANT.SETTINGS.SALES_COACH.SALES_METHODOLOGY.TITLE' | translate }}</glxy-label>
    <mat-select (selectionChange)="onSalesMethodologySelected($event)" [value]="value()" [disabled]="true">
      @for (methodology of methodologyOptions; track methodology.value) {
        <mat-option [value]="methodology.value">
          {{ methodology.name | translate }}
        </mat-option>
      }
    </mat-select>
  </glxy-form-field>
</form>
